module.exports = __webpack_public_path__ + "media/application/images/svgs/heart-484bcbc13049410f8619b2618d35afc0.svg";